import request from '@/utils/request'

let TestoneApi = {

  /*测试一列表*/
  list(data) {
    return request._post('/shop/plus.testone.Index/index', data);
},
/*添加测试一*/
add(data) {
    return request._post('/shop/plus.testone.Index/add', data);
},
/*修改测试一*/
edit(data) {
    return request._post('/shop/plus.testone.Index/edit', data);
},
/*删除测试一*/
del(data) {
    return request._post('/shop/plus.testone.Index/del', data);
},
/*测试一详情*/
detail(data) {
  return request._post('/shop/plus.testone.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.testone.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.testone.Setting/getSetting', data, errorback);
    },
}
export default TestoneApi;



// WEBPACK FOOTER //
// ./src/api/testone.js